import { fetchUserCurrentPreviewKey } from '@/data/api/user';

/**
 * Query function for retrieving current user preview key.
 *
 * @param {QueryFunctionContext<ReturnType<typeof authKeys.previewKey>>} context
 */
export function queryUserCurrentPreviewKey({ signal }) {
  return fetchUserCurrentPreviewKey(signal);
}
